import { accessTips } from "@/mocks/home";

export default function TipsSection() {
  return (
    <section id="tips" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[320px_1fr] gap-8 lg:gap-10">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-widest text-primary-600 uppercase">
              <i className="ri-tools-line" />
              Quick Fix
            </span>
            <h2 className="mt-3 font-heading font-black text-3xl md:text-4xl text-foreground-950">
              打不开怎么办
            </h2>
            <p className="mt-3 text-foreground-600 leading-relaxed">
              绝大多数“黑料入口打不开”，都不是站点没了，而是你这一条路临时不通。
              按下面四步顺一遍，基本都能解决，实在不行再等页顶广播更新新地址。
            </p>
            <div className="mt-6 p-4 rounded-lg bg-background-50 border border-background-200">
              <p className="text-sm text-foreground-700 leading-relaxed">
                <span className="font-medium text-primary-700">小提醒：</span>
                排查顺序很重要，先换网络，再清缓存，最后才换线路，能省下不少来回折腾的时间。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {accessTips.map((tip) => (
              <div
                key={tip.title}
                className="flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${tip.icon} text-2xl`} />
                </span>
                <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">
                  {tip.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}